import store from "~/store";
import swal from "sweetalert2";
import axios from "axios";

export default async (to, from, next) => {
  // if token not in local storage go to login
  if (!store.getters["auth/check"]) {
    next({ name: "login" });
    return;
  }

  // if user not present try to get user
  if (!store.getters["auth/user"]) {
    await store.dispatch("auth/fetchUser");

    if (!store.getters["auth/user"]) {
      return;
    }
  }

  // check disclaimer
  if (!store.getters["auth/disclaimer"]) {
    confirm = await swal({
      showCloseButton: true,
      showCancelButton: true,
      title: "Disclaimer",
      html:
        "<p>I hereby acknowledge and accept that the use of the GSMG trading platform is completely at my own risk. GSMG as a platform nor it's developers can be асcounted for/ sued in case of losses or other situations.</p><p>This includes, but is not limited to, the value of market itself, the trading algorithm nor the unfortunate choice of selected markets and other settings by the user. in to your account right now!</p>",
      customClass: "swal-login-register-disclaimer",
      confirmButtonText: "Accept",
      cancelButtonText: "Decline",
      imageUrl: "/img/popup_img_warning.png",
      imageHeight: 48,
      imageWidth: 48
    });

    if (confirm.dismiss) {
      await store.dispatch("auth/logout");

      next({ name: "login" });
      return;
    } else {
      try {
        const { data } = await axios.post("/api/v1/user/accept-disclaimer");
        await store.dispatch("auth/fetchUser");
        next();
        return;
      } catch (error) {
        await swal({
          title: "Disclaimer error",
          text: "Please contact GSMG",
          type: "error"
        });

        await store.dispatch("auth/logout");
        next({ name: "login" });
        return;
      }
    }
  }

  // token and user present, disclaimer is okay
  next();
};



// WEBPACK FOOTER //
// ./resources/js/router/middleware/auth.js